'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'

/**
 * The arriving page, lifted the last few pixels into place.
 *
 * Keyed on the path, which is what makes React mount a fresh element on every
 * navigation and therefore what makes the animation run again. The animation
 * itself is in CSS: the browser runs it on the compositor, so it costs nothing
 * at the moment a visitor has just clicked something.
 *
 * Nothing is animated on the way out. Holding a page somebody has already left
 * is latency they feel, and it is what makes an animated site feel slow rather
 * than considered.
 */
export function PageTransition({ children }: { children: ReactNode }) {
    const pathname = usePathname()

    return (
        <div key={pathname} data-page-enter>
            {children}
        </div>
    )
}
